import React from "react";
import FooterStyles from "../../styles/common/footer.module.css";

var Footer = function Footer() {
  return React.createElement("div", {
    className: FooterStyles.footerContainer + " py-2 py-sm-3 text-center"
  }, "Copyright \xA9 2019 niaefeup, todos os direitos reservados");
};

export default Footer;